import type { StepTransitionVariant } from "./form-types";

type StepTransitionVariantClasses = {
  /** Tailwind arbitrary-property transition, applied whenever the step is animated. */
  transitionClass: string;
  /** Exit-state classes: where the step animates to before the content swaps. */
  exitClasses: string;
};

// Offsets are deliberately smaller than AnimatedReveal's 32px scroll-reveal
// offset (see animation-variants.ts) — steps animate inside a fixed-height
// grid stack, where a large offset visibly overshoots the step's own box.
const STEP_TRANSITION_VARIANT_CLASSES: Record<
  StepTransitionVariant,
  StepTransitionVariantClasses
> = {
  fade: {
    exitClasses: "opacity-0",
    transitionClass: "transition-opacity",
  },
  "fade-down": {
    exitClasses: "-translate-y-3 opacity-0",
    transitionClass: "transition-[opacity,transform]",
  },
  "fade-left": {
    exitClasses: "translate-x-3 opacity-0",
    transitionClass: "transition-[opacity,transform]",
  },
  "fade-right": {
    exitClasses: "-translate-x-3 opacity-0",
    transitionClass: "transition-[opacity,transform]",
  },
  "fade-up": {
    exitClasses: "translate-y-3 opacity-0",
    transitionClass: "transition-[opacity,transform]",
  },
  scale: {
    exitClasses: "scale-95 opacity-0",
    transitionClass: "transition-[opacity,transform]",
  },
};

export { STEP_TRANSITION_VARIANT_CLASSES };
